
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/convert/[id]",
      function () {
        return require("private-next-pages/tools/convert/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/convert/[id]"])
      });
    }
  